import './i18n/i18n';
import 'common-components/style.css';
import '@definitions/styles/global.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StyleConfigProvider, antdLocales } from 'common-components';
import { useTranslation } from 'react-i18next';
import { ConsumerAuth, ProviderAuth } from '@components/auth';
import AppRouter from '@navigation/AppRouter';
import VersionFooter from '@components/VersionFooter';

function App() {
  const queryClient = new QueryClient();
  const { i18n } = useTranslation();
  return (
    <StyleConfigProvider locale={antdLocales[i18n.language] ?? antdLocales.fr}>
      <QueryClientProvider client={queryClient}>
        <div className="App">
          <ProviderAuth>
            <ConsumerAuth>
              <AppRouter />
            </ConsumerAuth>
          </ProviderAuth>
          <VersionFooter />
        </div>
      </QueryClientProvider>
    </StyleConfigProvider>
  );
}

export default App;
